module.exports = __webpack_public_path__ + "fonts/NanumSquareExtraBold.28631358.woff";